"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Section = exports.Root = exports.RightPanel = exports.Radio = exports.InfoLineText = exports.InfoLine = exports.DescriptionAndPrice = exports.Description = exports.DeliveryMethod = exports.DateAndAvailability = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'row',
  paddingTop: theme.spacing(3),
  '&:not(:last-of-type)': {
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    paddingBottom: theme.spacing(3)
  },
  [theme.breakpoints.up('md')]: {
    '&:hover': {
      [`& .${_mui.radioClasses.root}`]: {
        backgroundColor: (0, _mui.alpha)(theme.palette.primary.main, 0.15)
      }
    }
  }
}));
const RightPanel = exports.RightPanel = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  width: '100%'
}));
const DeliveryMethod = exports.DeliveryMethod = (0, _mui.styled)(_mui.Chip)({
  maxWidth: 'fit-content'
});
const DescriptionAndPrice = exports.DescriptionAndPrice = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'start',
  display: 'flex',
  gap: theme.spacing(3),
  justifyContent: 'space-between'
}));
const Radio = exports.Radio = (0, _mui.styled)(_mui.Radio)(({
  theme
}) => ({
  marginLeft: theme.spacing(-2),
  marginTop: theme.spacing(4)
}));
const DateAndAvailability = exports.DateAndAvailability = (0, _mui.styled)('div')(({
  theme
}) => ({
  color: theme.palette.text.secondary,
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(3),
  '&:empty': {
    display: 'none'
  }
}));
const InfoLine = exports.InfoLine = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  color: theme.palette.text.secondary,
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(2),
  '& p': {
    lineHeight: '2.4rem'
  },
  '& svg': {
    alignSelf: 'start'
  }
}));
const InfoLineText = exports.InfoLineText = (0, _mui.styled)(_mui.Typography)({
  display: '-webkit-box',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2
});
const Section = exports.Section = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  '&:empty': {
    display: 'none'
  }
}));
const Description = exports.Description = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  color: theme.palette.text.primary,
  fontWeight: theme.typography.fontWeightBold
}));